var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkiMount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M51.4,132.6v-54h23.1c0,0,0,20.8,0,20.8c0,2.8,2.3,5.1,5.1,5.1c2.8,0,5.1-2.3,5.1-5.1c0,0,0-25.9,0-25.9 c0-2.8-2.3-5.1-5.1-5.1H41.1v64.3c0,2.8,2.3,5.1,5.1,5.1C49.1,137.7,51.4,135.4,51.4,132.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 61.7,
    cy: 15.6,
    rx: 9,
    ry: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5,144h3.8l50.1-50.1c4-4,4-10.6,0-14.7l-1.9,1.9c3,3,3,7.8,0,10.8L48.5,144z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.2,33.6c1.1-2,0.8-4.5-0.8-6.2c-2-2-5.3-2-7.3,0L67.4,38.1L56.5,27.2c-1.8-1.8-4.1-2.6-6.4-2.6l-14.8,0 c-2.5,0-4.5,2-4.5,4.5v19.2c0,2.5,2,4.5,4.5,4.5h5.8v10.3h18V44.4c0,0,4.6,4.6,4.7,4.7c0.9,0.9,2.2,1.5,3.6,1.5s2.7-0.6,3.6-1.5 l13.3-13.3l38.7,38.7l1.9-1.9L86.2,33.6z M41.1,50.1h-5.8c-1,0-1.8-0.8-1.8-1.8V29.1c0-1,0.8-1.8,1.8-1.8h5.8V50.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkiMount);
export default __webpack_public_path__ + "static/media/skiMount.0e3ba2d32bfaf8921f9051357d2d962e.svg";
export { ForwardRef as ReactComponent };